import React, {useRef, useState, useEffect, useCallback, useMemo} from "react";
import {useLoader, useThree} from "@react-three/fiber";
import {STLLoader} from "three/addons/loaders/STLLoader";
import {GLTFLoader} from "three/addons/loaders/GLTFLoader";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import {Line, PivotControls, Center} from "@react-three/drei";
import {connect} from "react-redux";
import action from "../../../store/action";
import {
    getToothModelUrl,
} from '../../../dataInterface/toothData'
import * as THREE from 'three'
import {mergeVertices} from "three/addons/utils/BufferGeometryUtils";
import store from "../../../store";


/**
 * @description create tooth function. In order to batch creation tooth
 * @param props The parameter passed by the attribute within the tag
 * */
function Superimposition(props) {
    /**
     * @param itemId String    component itemId
     * @param url String     model path
     * @param color String     model material color
     * */
    const {
        itemId,
        setCurrentClickItemId,
        setCurrentClickInitItemRef,
        currentClickItemId,
        initTooth, // Determine if the tooth is in overlay mode
        dragging,
        keyframeNumber,
        initMatrix=null,
        setCurrentClickPontic,
        url,
        opacity,
        fileType
    } = props

    const ref = useRef()



    useEffect(()=> {

        if(itemId === currentClickItemId && initTooth) {

            setCurrentClickInitItemRef(ref.current)
        }

    }, [currentClickItemId])

    //load model
    let loader = STLLoader

    if(fileType === 'drc') {
        loader = DRACOLoader
    }

    let model = useLoader(loader, url, loaderInstance=> {

        if(loaderInstance instanceof DRACOLoader) {

            loaderInstance.setDecoderPath('/draco/');
            loaderInstance.setDecoderConfig({ type: 'js' });
        }

    })


    const clickHandler = useCallback((e) => {

        if (dragging || initTooth) {
            return
        }

        if(e.eventObject.material.opacity === 1 && e.eventObject.visible) {

            e.stopPropagation()

            setCurrentClickItemId(itemId)

            setCurrentClickPontic(null)

        }

        // ToothDataPro prevent a bubble



    }, [])




    useEffect(()=> {
        if(ref.current) {

            ref.current.geometry.deleteAttribute("normal")
            ref.current.geometry = mergeVertices(ref.current.geometry, 0.1);
            ref.current.geometry.computeVertexNormals(true);

        }
    }, [])

    useEffect(() => {
        if(ref.current) {
            if(!ref.current.geometry)
                return
            if(!ref.current.geometry.attributes)
                return
            const vertices = ref.current?.geometry.attributes.position.array
            if(!ref.current.geometry.attributes.normal)
                return
            const normal = ref.current?.geometry.attributes.normal.array


            for (let i = 0; i < vertices.length; i += 3) {
                const vertex = new THREE.Vector3(vertices[i], vertices[i + 1], vertices[i + 2]);
                let normalVertex = new THREE.Vector3(normal[i], normal[i + 1], normal[i + 2])

                normalVertex = normalVertex.multiplyScalar(0.01)

                vertices[i] = vertex.x - normalVertex.x;
                vertices[i + 1] = vertex.y  - normalVertex.y;
                vertices[i + 2] = vertex.z  - normalVertex.z;
            }

            // ref.current.geometry.computeFaceNormals();
            ref.current.geometry.computeVertexNormals();
            ref.current.geometry.attributes.position.needsUpdate = true;
        }
    }, [ref.current?.geometry]);



    return (
        <mesh
            {...props}
            ref={ref}
            geometry={model}
            renderOrder={1}
            matrix={initMatrix}
            matrixAutoUpdate={false}
            // scale={initTooth ? 1 : (visibility === 1 && stage === keyframeNumber) ? 1 : 0}
            // visible={initTooth ? true : (visibility === 1 && stage === keyframeNumber) ? true : false}
            onClick={(event) => clickHandler(event)}
            name={itemId}
        >
            <meshPhysicalMaterial
                attach="material"
                color={currentClickItemId == itemId ? '#0000CD' : '#6495ED'}
                opacity={opacity > 0.5 ? 0.5 : opacity}
                transparent={true}
                depthWrite={opacity > 0.5 ? true : false}
                depthTest={true}
                clearcoat={1}
                clearcoatRoughness={0.3}
                roughness={0.2}
                metalness={0}
                reflectivity={0.3}
                emissive={'#FFFAF0'}
                emissiveIntensity={0.05}
            />
        </mesh>
    )
}

const mapStateToProps = state => ({
    sliderVal: state.webViewer.sliderVal,
    view: state.webViewer.view,
    currentClickItemId: state.webViewer.currentClickItemId,
    dragging: state.webViewer.dragging,
    toothData: state.webViewer.toothData,
    keyframeNumber: state.webViewer.keyframeNumber,
    attachmentCheckboxValue: state.webViewer.attachmentCheckboxValue,
    panelData: state.webViewer.panelData,
    cameraControlRef: state.webViewer.cameraControlRef,
    gridCheckboxValue: state.webViewer.gridCheckboxValue,
    isMobile: state.webViewer.isMobile,
    editMode: state.webViewer.editMode,
})

const mapDispatchToProps = dispatch => ({
    setView: val => dispatch(action.setView(val)),
    setCurrentClickItemId: val => dispatch(action.setCurrentClickItemId(val)),
    setCurrentClickPontic: val => dispatch(action.setCurrentClickPontic(val)),
    setCurrentClickItemRef: val => dispatch(action.setCurrentClickItemRef(val)),
    setCurrentClickInitItemRef: val => dispatch(action.setCurrentClickInitItemRef(val)),
    setDragging: val => dispatch(action.setDragging(val)),
    setToothData: val => dispatch(action.setToothData(val)),
    setPivotData: val => dispatch(action.setPivotData(val)),
    setPanelData: val => dispatch(action.setPanelData(val)),
})

export default connect(mapStateToProps, mapDispatchToProps)(Superimposition)
